import theme from 'theme'

/* The UI library gives Input and Dropdown one shared border matrix — default
 * Stroke/secondary, hover Stroke/tertiary, focus CTA, error throughout. Both
 * field components draw from here so they cannot drift apart.
 * Applies to the .MuiOutlinedInput-root / .MuiSelect-root element. */
export const inputFieldStates = (errored = false) => `
  border: 1px solid ${errored ? theme.colors.inputError : theme.colors.dropdownBorder};
  border-radius: ${theme.attributes.borderRadius.tertiary};

  /* The outline lives on the root, so MUI's notched fieldset stays invisible. */
  fieldset {
    border: none;
  }

  &:hover:not(.Mui-disabled):not(.Mui-focused) {
    border-color: ${errored ? theme.colors.inputError : theme.colors.strokeTertiary};
  }

  &.Mui-focused {
    border-color: ${errored ? theme.colors.inputError : theme.colors.cta};
  }

  &.Mui-focused fieldset {
    border: none;
  }

  &.Mui-disabled {
    border-color: ${theme.colors.dropdownBorder};
  }
`

/* Field value ramp: a real value reads primary, a placeholder secondary. */
export const inputValueStyles = `
  color: ${theme.colors.menuItemText};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 20px;
  letter-spacing: 0.1px;

  &::placeholder {
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${theme.colors.devicesSecondaryText};
    -webkit-text-fill-color: ${theme.colors.devicesSecondaryText};
    opacity: 1;
  }

  &.Mui-disabled {
    color: ${theme.colors.btnSecondaryDisabledText};
    -webkit-text-fill-color: ${theme.colors.btnSecondaryDisabledText};
  }
`

/* The label above the field, as the wizard's input instances draw it. */
export const inputLabelStyles = `
  color: ${theme.colors.devicesSecondaryText};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.normal};
  line-height: 22px;
`
